import { TAB_LINK_CLASS_NAME, MIN_WIDTH_FROM_TAB_COUNT, DEFAULT_LINK_CLASS_NAME, NAVBAR_LINK_CLASS_NAME, PRIMARY_LINK_CLASS_NAME, NAVBAR_ROUTE_CLASS_NAME } from '../../constants/link';

const globalStyles = ({ theme }) => ({
  cursor: 'pointer',
  '&[disabled]': {
    color: theme.palette.gray.A600,
    pointerEvents: 'none',
  },
});

const tabLink = ({ theme }) => ({
  textDecoration: 'none',
  backgroundColor: '#CCCCCC',
  color: 'white',
  padding: 4,
  borderTopLeftRadius: 8,
  borderTopRightRadius: 8,
  marginLeft: 16,
  minWidth: 220,
  maxWidth: 280,
  textAlign: 'center',
  '&:first-of-type': {
    marginLeft: 0,
  },
  [theme.breakpoints.down('md')]: {
    marginLeft: '1%',
    fontSize: 12,
    // Dynamic min-width set via CSS variable from component based on tab count
    minWidth: `var(--${MIN_WIDTH_FROM_TAB_COUNT})`,
  },
  [theme.breakpoints.down('s')]: {
    fontSize: 9,
  },
  '&.active': {
    backgroundColor: 'white',
    color: theme.palette.primary.main,
  },
});

const defaultLink = ({ theme }) => ({
  color: theme.palette.primary.main,
});

const navbarLink = ({ theme }) => ({
  sx: {
    '&:hover': {
      color: theme.palette.primary.main,
      textDecoration: 'none',
    },
  },
});

const primaryLink = ({ theme }) => ({
  color: theme.palette.primary.main,
});

const navbarRoute = ({ theme }) => ({
  ...theme.typography.h2,
  color: theme.palette.text.primary,
  '&:hover': {
    color: theme.palette.primary.main,
    textDecoration: 'none',
  },
  '&.active': {
    color: theme.palette.primary.main,
    fontWeight: '500',
  },
  textDecoration: 'none',
  whiteSpace: 'nowrap',
});

export const underlineTabLink = ({ theme, accentColor }) => ({
  textDecoration: 'none',
  backgroundColor: 'white',
  color: theme.palette.gray.main,
  paddingLeft: 16,
  paddingRight: 16,
  paddingTop: 8,
  paddingBottom: 8,
  marginLeft: 16,
  minWidth: 220,
  maxWidth: 280,
  borderTopLeftRadius: 8,
  borderTopRightRadius: 8,
  textAlign: 'center',
  '&:first-of-type': {
    marginLeft: 0,
  },
  [theme.breakpoints.down('md')]: {
    marginLeft: '1%',
    fontSize: 12,
    // Dynamic min-width set via CSS variable from component based on tab count
    minWidth: `var(--${MIN_WIDTH_FROM_TAB_COUNT})`,
  },
  [theme.breakpoints.down('s')]: {
    fontSize: 9,
  },
  '&.active': {
    color: accentColor,
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      background: accentColor,
      height: 4,
      borderRadius: 8,
    },
  },
  '& .MuiTypography-subNavItem': {
    fontWeight: '200',
    fontSize: 18,
    lineHeight: 1.1,
  },
});

const MuiLink = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...globalStyles({ theme }),
      [`&.${TAB_LINK_CLASS_NAME}`]: tabLink({ theme }),
      [`&.${DEFAULT_LINK_CLASS_NAME}`]: defaultLink({ theme }),
      [`&.${NAVBAR_LINK_CLASS_NAME}`]: navbarLink({ theme }),
      [`&.${PRIMARY_LINK_CLASS_NAME}`]: primaryLink({ theme }),
      [`&.${NAVBAR_ROUTE_CLASS_NAME}`]: navbarRoute({ theme }),
    }),
  },
};

export default MuiLink;
